/** 直前に閲覧していたページPATHを保存. */
export const SAVE_PREV_PAGE = "SAVE_PREV_PAGE";